import { baseStyles, buttonStyles, stepContainerStyles } from '@/styles';
import { t } from 'i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconCheckmarkCircleTransparent } from '@/components/icons';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';

/**
 * @element fg-personalisation-step-done
 */
@customElement('fg-personalisation-step-done')
export class FgPersonalisationStep extends LitElement {
  @property({ type: String })
  fileName?: string;

  private close() {
    this.dispatchEvent(
      new Event('personalisation-completed', { composed: true }),
    );
  }

  render() {
    return html`
      <div class="step-container">
        ${this.fileName
          ? html`
              <span class="file-name">${this.fileName}</span>
            `
          : nothing}
        <div class="done-container">
          <div class="done-icon">${iconCheckmarkCircleTransparent}</div>
          <strong class="done-message">
            ${t('content.personalisation.doneStep.printAdded')}
          </strong>
          <strong class="done-message">
            ${t('content.personalisation.doneStep.afterOrder')}
          </strong>
          <button class="button button-primary" @click=${() => this.close()}>
            ${t('actions.close')}
          </button>
        </div>
      </div>
    `;
  }
  static styles = [
    baseStyles,
    buttonStyles,
    stepContainerStyles,
    css`
      .file-name {
        margin-bottom: 20px;
      }
      .done-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 15px;
      }
      .done-icon {
        color: var(--fg-cta, var(--fg-fallback-cta));
        margin-bottom: 10px;
      }
      .done-icon svg {
        width: 73px;
        height: 73px;
      }
      .done-message {
        font-size: 1.125rem;
        line-height: 1.75rem;
        font-weight: 700;
        text-align: center;
      }
      .button {
        margin-top: 20px;
        width: 100%;
      }
      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}) {
        .button {
          min-width: 310px;
        }
        .done-container {
          margin: 24px 30px 20px;
        }
      }
    `,
  ];
}
